import { IconProps } from "../../../types/style";

const PlayFillIcon = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.98486 1C3.22486 1 0.984863 3.24 0.984863 6C0.984863 8.76 3.22486 11 5.98486 11C8.74486 11 10.9849 8.76 10.9849 6C10.9849 3.24 8.74986 1 5.98486 1ZM7.48486 7.115L6.03486 7.95C5.85486 8.055 5.65486 8.105 5.45986 8.105C5.25986 8.105 5.06486 8.055 4.88486 7.95C4.52486 7.74 4.30986 7.37 4.30986 6.95V5.275C4.30986 4.86 4.52486 4.485 4.88486 4.275C5.24486 4.065 5.67486 4.065 6.03986 4.275L7.48986 5.11C7.84986 5.32 8.06486 5.69 8.06486 6.11C8.06486 6.53 7.84986 6.905 7.48486 7.115Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default PlayFillIcon;
